/*
 * メッセージ用 アコーディオンパネル 定義コンポーネント
 * 共通部品
 * c-msgdisp
 */
<template>
	<div>
		<div v-if="r_err_msg.length > 0">
			<div v-for="msg in r_err_msg" >
				<div v-if="msg.rec && msg.rec.length>0 && msg.rec[0] != null">
					<c-view-accordion v-for="errs in msg.rec" :r_title="createErrMassages(errs)" :r_id="errs.idx + 'err'" r_class="err" :key="errs.idx + 'err'" :r_iscollapse="false">
						<c-message-list :r_errors="errs.errors">
						</c-message-list>
					</c-view-accordion>
				</div>
				<div v-else-if="msg.result > 1000">
					<div class='error-messages'><!--
					-->{{msg.errmessage}}
					</div>
				</div>
				<div v-else >
					<div class='error-messages' v-html="msg"></div>
				</div>
			</div>
		</div>
		<div v-else-if="r_info_msg.length > 0">
			<div v-for="msg in r_info_msg" >
				<div v-if="msg.result == 0 || msg.result == 300">
					<div class='success-messages' v-if="msg.message != ''"><!--
					-->{{msg.message}}
					</div>
				</div>
				<div v-else-if="msg.result > 0">
					<div class='success-messages'>
						<font class="text-red">{{msg.message}}</font>
					</div>
				</div>
				<div v-else >
					<div v-if="msg != ''">
						<div class='success-messages' v-html="msg"></div>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="r_initial_msg.length > 0">
			<div v-for="msg in r_initial_msg" >
				<div class='initial-messages' v-html="msg"></div>
			</div>
		</div>
	</div>
</template>
<script>
	/**
	 * メッセージ用 アコーディオンパネル 定義コンポーネント.<br>
	 * @module js\parts_unit\MessageAccordion
	 * @example
	 * <c-message-accordion
	 * >
	 * </c-message-accordion>
	 **/

	/**
	 * props 引数
	 * @param {string[]} messages - 表示文言
	 * @param {string[]} error_messages - エラーメッセージ
	 **/
	 export default {
		props:{
			r_messages: {},
			r_info_msg: {
				default: function () {
					return [];
				}
			},
			r_err_msg: {
				default: function () {
					return [];
				}
			},
			r_initial_msg: {
				default: function () {
					return [];
				}
			},
			// エラー時のメッセージの出し方
			// 0:x行目 1:x番目
			r_idx_type: {
				type: Number,
				default: 0
			},
		},
		methods: {
			createErrMassages: function ( errs ){
				var idx = errs.idx;
				if(this.r_messages){
					return idx + this.r_messages.idx + " : " + this.r_messages.error_regist;
				}
				console.log("createErrMassages r_messages none.");
				return "Error at " + idx;
			},
			getEmbedTextForError:function(errs){
				var text = "";
				if ( errs.code == "" || errs.code == undefined ) {
					if ( errs.name ) {
						text = errs.name_label + ":" + errs.name;
					}
				} else {
					text = errs.code_label + ":" + errs.code;
				}
				return text;
			},
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/viewMessageDisp.vue